import { forwardRef, type LegacyRef } from 'react';
import ImageWidgetConfigContent from './ImageWidgetConfigContent';

export interface ImageWidgetConfigProps {
  project_id: number;
  site_id: number;
  open: boolean;
  grid_type: 'reports' | 'grids';
}

function ImageWidgetConfig(
  {
    open: _isModalOpen,
    site_id,
    project_id,
    grid_type,
  }: ImageWidgetConfigProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return (
    <ImageWidgetConfigContent
      site_id={site_id}
      project_id={project_id}
      grid_type={grid_type}
      ref={ref}
    />
  );
}

export default forwardRef(ImageWidgetConfig);
